import { doFetch, doPostFetch, doDeleteFetch } from "./apiFetchHelper";
const API_URL = `/api/favorites`;

export function getFavorites() {
  return doFetch(`${API_URL}`);
}

export function addFavorite(id) {
  const payload = {
    brand_id: id,
  };
  return doPostFetch(`${API_URL}`, payload);
}

export function removeFavorite(id) {
  const payload = {
    favoriteId: id,
  };
  return doDeleteFetch(`${API_URL}`, payload);
}

export function getFavoritedStores(data) {
  const payload = {
    storeKeys: data.storeKeys,
    fields: "name, logo_url, store_key",
  };
  return doPostFetch(`${API_URL}/lookup`, payload);
}

export default {
  getFavorites,
  addFavorite,
  removeFavorite,
  getFavoritedStores,
};
